import $ from "cash-dom"
import _ from "lodash"
import React from "react"
import {createRoot} from "react-dom/client"
import EmbeddedVideo from "components/embedded_video"
import Contentbox from "components/contentbox"
import viewport_helper from "viewport_helper"
import vimeo_manager from "vimeo_manager"
import lazy_loader from "lazy_loader"
import ajax from "ajax"

const init_embedded_video = (container) => {
  const $container = $(container)
  const video_id = $container.data("video-id")
  return get_video_data(video_id).then((video) => {
    if ($container.hasClass("contentbox-container")) {
      create_video_contentbox(container, video)
    } else {
      create_embedded_video(container, video)
    }
    $container.removeClass("spinner")
  })
}

export const init_embedded_videos = () => {
  lazy_loader.add($("[data-video-id]"), (container) =>
    init_embedded_video(container).then(() => {
      if (container.id && window.location.hash.match(container.id)) {
        container.children[0].click()
      }
    })
  )
}

export function create_embedded_video(
  container,
  video,
  show_content_tabs = true,
  auto_play = false,
  start_time
) {
  createRoot(container).render(
    <EmbeddedVideo
      title={video.title}
      html_title={video.html_title}
      auto_play={auto_play}
      play_time={video.play_time}
      language={video.language}
      description={video.description}
      transcript={video.transcript}
      timestamps={video.timestamps}
      vimeo_id={video.vimeo_id}
      vimeo_thumbnail_url={video.vimeo_thumbnail_url}
      small_vimeo_thumbnail_url={video.small_vimeo_thumbnail_url}
      can_watch_full_video={video.can_watch_full_video}
      restricted={video.restricted}
      tracking_data={create_tracking_data(video)}
      show_content_tabs={show_content_tabs}
      start_time={start_time}
    />
  )
}

const create_tracking_data = (video) => {
  const tracking_data =
    window.gon.tracking?.study_unit ||
    window.gon.tracking?.article ||
    {}
  return Object.assign(
    video.tracking_data,
    _.pick(tracking_data, [
      "section_slug",
      "lecture_slug",
      "chapter_slug"
    ])
  )
}

export const create_video_contentbox = (container, video) => {
  const root = createRoot(container)

  const on_click_callback = () => {
    vimeo_manager.pause_all()
    root.unmount()
    create_embedded_video(container, video)
    viewport_helper.go_to(container)
  }

  root.render(
    <Contentbox
      title={video.title}
      description={video.description}
      image_url={video.thumb_url}
      on_click={on_click_callback}
      type="video"
    />
  )
}

export const get_video_data = (id) => {
  // we provide the data for the first video on articles on page load
  // if it is on top of the page
  if (window.gon.videos && window.gon.videos[id]) {
    return Promise.resolve(window.gon.videos[id])
  }
  return ajax.get(`/api/videos/${id}.json`)
}

export default init_embedded_video
